import React from "react";
import { state, ui } from "../../../../../../../../../interfaces/interfaces";
import { QuestionsUtils } from "@utils/questions";

export const handleClose = (questionsUtils: QuestionsUtils) => {
    generateNotesForRequiredOptions(questionsUtils)
    ui.RequiredModal = false
};

export const handleSave = (questionsUtils: QuestionsUtils) => {
    generateNotesForRequiredOptions(questionsUtils)
    ui.RequiredModal = false
};

type HandleChange = {
    (event: React.ChangeEvent<HTMLInputElement>, value: any, questionsUtils: QuestionsUtils, index: number): void
}

export const handleChange: HandleChange = (event, value, questionsUtils, index) => {
    value = value ? value : event.target.value ? event.target.value : ""

    // we need to set following values to state if dependent question is answered
    const questions = questionsUtils.generateQuestions()
    const numQuestions = questions.length // get number of questions
    const nextQuestion = numQuestions > index + 1 ? questions[index + 1] : null // get next question if it exists
    if (nextQuestion && nextQuestion.dependent) {
        // reset next question if it is dependent
        questionsUtils.setAnswer(index + 1, "")
    }

    index < 99 && questionsUtils.setAnswer(index, value)
};

export const generateNotesForRequiredOptions = (questionsUtils: QuestionsUtils) => {
    let note = questionsUtils.generateNotes()
    note += state.RequiredOption10Answer ? "Extra Notes: " + state.RequiredOption10Answer : "";
    state.NotesJob = note
}